import React from 'react';
import classname from 'classnames';
import styles from './index.module.scss';

export default function Policy() {
  return (
    <div className={styles.policy}>
      <p className={classname(styles.title, styles.center)}>私隐政策</p>
      <p className={styles.msg}>
        联成都音线网络科技有限公司（成都音线网络科技有限公司的全资附属公司(以下简称为「我们」、「我们」、「本公司」或「正念」)尊重任何使用本公司网页及移动应用程式的人士或参加正念的活动或登记使用正念的服务或网上内容包括但不限于我们合作伙伴的产品及服务(以下简称为「服务」)
        的人士的私隐权。我们会确保所收集、传送、储存及使用的个人资料将遵照香港特别行政区法例第486章《个人资料(私隐)条例》(以下简称为「条例」)的规定处理。若提供个人资料予我们，则被视作同意此私隐政策。
      </p>
      <p className={styles.msg}>「个人资料」一词含有条例所解释的意义。</p>
      <p className={styles.msg}>收集个人资料的目的及用途</p>
      <p className={styles.msg}>
        你毋须提供任何个人资料以浏览或使用本网页及移动应用程式。当你参加正念的活动或登记使用我们的服务或网上内容，我们会收集你的个人资料使我们能够为你提供服务。你可拒绝向我们提供个人资料，但在此情况下，我们可能无法为你提供服务。阁下提供个人资料，即代表阁下同意我们按本私隐政策声明使用阁下的个人资料。
      </p>
      <p className={styles.msg} style={{ height: 21 }}></p>

      <p className={styles.keynote}>
        正念从你收集所得的个人资料可能会用于以下用途（包括但不限于）
      </p>

      <p className={styles.msg}>· 识别你的身分及你开设的任何账户</p>
      <p className={styles.msg}>· 为你提供服务</p>
      <p className={styles.msg}>· 核实身分及／或作信贷审查</p>
      <p className={styles.msg}>
        · 确定及核实你享用商品和服务的折扣及促销的资格
      </p>
      <p className={styles.msg}>
        · 代表你处理申请及更新合作伙伴的产品及服务，包括但不限于保险及财务产品
      </p>
      <p className={styles.msg}>· 代表你处理合作伙伴的产品及服务之保险索偿</p>
      <p className={styles.msg}>· 为你处理与服务有关的付款指示或追收欠款</p>
      <p className={styles.msg}>
        ·
        让本网站储存你的个人资料，以免你每次购买产品或更新保险产品时需要重新输入相关资料
      </p>
      <p className={styles.msg}>· 处理订单、开出账单及履行订单</p>
      <p className={styles.msg}>
        · 直接促销我们的 服务（详情见「直接促销」部份）
      </p>
      <p className={styles.msg}>
        · 直接促销本公司业务伙伴的产品及服务（详情见「直接促销」部份）
      </p>
      <p className={styles.msg}>· 为你设计所需服务</p>
      <p className={styles.msg}>· 进行市场研究、统计分析及行为分析</p>
      <p className={styles.msg}>· 进行节目收视调查及分析</p>
      <p className={styles.msg}>· 进行顾客数据分析及分析你的购物喜好</p>
      <p className={styles.msg}>
        ·
        让你选择参与我们为你提供的服务的互动功能，包括识别你的朋友，并与他们沟通和分享你的购物体验
      </p>
      <p className={styles.msg}>· 就我们的服务或你感兴趣的商品或服务向你推荐</p>
      <p className={styles.msg}>· 设计本公司网站及内容，迎合你的特定喜好</p>
      <p className={styles.msg}>· 为你提供客户服务</p>
      <p className={styles.msg}>
        · 处理你的投诉及账户查询，对本公司或任何一方之索偿及/或诉讼
      </p>

      <p className={styles.msg}>· 防范及阻止欺诈</p>
      <p className={styles.msg}>· 审计目的</p>
      <p className={styles.msg}>· 按适用法律、规则及规例的规定作出披露</p>
      <p className={styles.msg}>
        · 任何与收集个人资料的原来目的直接有关之其他用途
      </p>
      <p className={styles.msg} style={{ height: 21 }}></p>
      <p className={styles.keynote}>所收集的个人资料类别</p>
      <p className={styles.msg}>
        香港电视所收集的个人资料可能包括（包括但不限于）：
      </p>
      <p className={styles.msg}>
        1.
        你的个人资料及联络资料，如姓名、性别、出生日期、身分证号码、电话号码、社交媒体连结、电
        邮地址、住址、邮寄地址及/或寄发账单的地址；
      </p>
      <p className={styles.msg}>2. 你的商业资料，如公司的名称及职衔；</p>
      <p className={styles.msg}>
        3. 你的账户资料，如信用卡账户号码首尾4位数或用户账号；
      </p>
      <p className={styles.msg}>4. 你的家庭收入及个人兴趣；及</p>
      <p className={styles.msg}>
        5.
        你的电脑或移动装置IP地址、即时位置资料、浏览器设定、浏览纪录及／或其他互联网记录的资料；及
      </p>
      <p className={styles.msg}>
        6.
        你的电话簿中包含的电话号码和电子邮件地址(当你使用我们为你提供的服务的互动功)。当你接受我
        们的服务我们会通知你。当你提供数据给我们，你确认已经从电话簿的联系人取得同意。
      </p>
      <p className={styles.msg} style={{ height: 21 }}></p>
      <p className={styles.keynote}>个人资料之保密、披露及保安</p>
      <p className={styles.msg}>
        正念收集及持有关于你的个人资料均会被保密处理；但若需要按法例的规定或要求而履行法律责任，或为你提供服务，或执行收集个人资料的原来目的或直接有关之目的，本公司有可能会向下述人士披露该等资料（不论其身处香港或香港境外）：
      </p>
      <p className={styles.msg}>
        · 具管辖权的法院、执法机关、或其他政府法定或监管部门、机构或组织
      </p>
      <p className={styles.msg}>
        ·
        本公司之联系公司、合作伙伴、参与服务销售及市场推广或行政，或提供货品╱服务的卖家或承办商、代理或其他服务供应商
      </p>
      <p className={styles.msg}>
        ·
        本公司之合作伙伴包括但不限于保险公司，此可评估及处理保险产品申新、更新申请、保险索偿及和解、提供保险服务及/或处理查询或投诉
      </p>
      <p className={styles.msg}>
        ·
        任何对本公司有保密责任的其他人士，包括已承诺保密该等资料的公司集团成员、资讯科技顾问、资料处理承办商、审计师、会计师、或律师
      </p>
      <p className={styles.msg}>
        · 银行、金融机构、保险公司、信用卡发行公司或追收欠款服务公司
      </p>
      <p className={styles.msg}>
        任何由你传送或登载于我们网站或网站任何部份的问题、意见、建议或资料，除个人资料外，均视作以非保密及非专有资料的形式自愿提供予本公司。我们有权自行将该等资料在其他地方使用、複製、披露、传送、刊载及/或登载，包括但不限于为服务的开发和推广及为满足客户的需要等目的，而将该等资料提供给任何联系公司。
      </p>
      <p className={styles.msg}>
        我们有可能会公开共享非个人资料，例如包括但不限于与销售交易、用户流量、物流及仓库绩效有关之匿名数据和汇总数据，并有可能会与我们的合作伙伴共享，包括但不限于与现有及潜在商业合作伙伴、提供货品╱服务的卖家或承办商、初创企业家及学界等。
      </p>
      <p className={styles.msg}>
        正念将尽一切合理的努力以确保香港电视持有的所有个人资料均储存于可靠稳妥及安全的地方。
      </p>
      <p className={styles.msg}>
        我们会尽力将收集到的所有个人资料保密。然而，请你理解我们不可能保证传输资料的安全。
      </p>
      <p className={styles.msg}>
        若你购买我们合作伙伴的保险产品或其他产品或服务，你的个人资料将会被传送至合作伙伴及你的个人资料将会根据合作伙伴的私隐政策被使用、处理及保留。此乃超出我们的控制。详情请参阅合作伙伴之私隠政策。
      </p>
      <p className={styles.msg} style={{ height: 21 }}></p>
      <p className={styles.keynote}>将个人资料转移至香港以外地方</p>
      <p className={styles.msg}>
        若在运作上有需要，本公司会将个人资料转移至香港特别行政区以外的地方以达到收集此等资料之目的，或直接与其有关之目的。
        任何有关的资料转移都会遵照条例之规定及约束。
      </p>
      <p className={styles.msg} style={{ height: 21 }}></p>
      <p className={styles.keynote}>个人资料的保存</p>
      <p className={styles.msg}>
        如果你选择或提供用户识别码，密码或任何其他信息作为安全程序的一部分，你必须将这些信息视为保密信息。你不得将其透露给任何第叁方。如果你的手机号码用于帐户登录，你应确保在你的手机号码被更改或交还流动电讯营运商时，通过在“账户资料”中登录你的账户进行及时更新。这对于确保你的帐户信息不会被可能已经获得了使用你已交还的手机号码权利的第叁方存取非常重要。你须负责以这种特定的方式保护你的帐户。我们对此不承担任何责任。
      </p>
      <p className={styles.msg}>
        除非法律规定要求正念须保存你的个人资料一段特定的时间，正念只会将个人资料保存至达到收集个人资料之原来目的，或直接与其有关之目的为止。
      </p>
      <p className={styles.msg} style={{ height: 21 }}></p>
      <p className={styles.keynote}>直接促销</p>
      <p className={styles.msg}>
        正念或将向你收集的个人资料用于发送消息、优惠、宣传及市场报价用途，就此而言，本公司须要取得你的同意。我们可透过电邮、移动应用程式通知、社交媒体连结、短讯、文字／图像／视像讯息、电话或邮件等方式联络你。本公司持有你的姓名、电邮地址、电话号码、联络地址、社交媒体连结、产品及服务组合资料、交易模式及行为、浏览纪录、节目收看习惯、个人兴趣，本公司可使用有关资料作直接促销我们的服务，以及以下我们的业务伙伴的产品及服务，或亚洲电脑应用程式商户的产品或服务类别之用，包括但不限于食品及饮料、杂货、家居用品、个人护理及保健、护肤及化妆品、母婴用品、宠物用品、电子电器、家品家俬、吃喝玩乐、运动旅行、玩具图书、电讯、媒体及娱乐、时装、保险和财务产品类别及为慈善、文化、公益或康体目的索求捐赠或贡献等你可能感兴趣的产品、服务或项目。
      </p>
      <p className={styles.msg}>
        如果你不希望收到我们及合作伙伴发出的任何直接促销通讯，可以随时透过你的注册账户或我们提供的取消订阅连结更新你的喜好。在收到你通知后，我们将停止使用你的个人资料作直接促销之用，并不会就此向你收费。
      </p>
      <p className={styles.msg} style={{ height: 21 }}></p>
      <p className={styles.keynote}>使用「曲奇」档桉 (COOKIES)</p>
      <p className={styles.msg}>
        「曲奇」档桉是一个当你进入本公司网页及移动应用程式时存储于你的电脑（或其他电子装置）的小型文字档。我们在本网页使用「曲奇」档桉，以便：
      </p>
      <p className={styles.msg}>· 在你浏览本网页及移动应用程式时辨认你的身分</p>
      <p className={styles.msg}>
        · 取得有关你喜好的资料、查阅及浏览行为、网上活动及互联网的使用情况
      </p>
      <p className={styles.msg}>
        · 持续追踪你购物篮内储存的项目，协助你通过结账的手续
      </p>
      <p className={styles.msg}>
        · 进行研究及统计分析，协助我们改善服务，更了解访客及访客的要求及兴趣
      </p>

      <p className={styles.msg}>
        ·
        提供切合你个人兴趣的广告，更有效地进行我们、业务伙伴及广告商的促销及广告计划
      </p>
      <p className={styles.msg}>· 使你的网上活动更有效率，体验更佳</p>
      <p className={styles.msg}>· 使安全措施更严密</p>
      <p className={styles.msg}>
        我们使用「曲奇」档桉取得的资料可能不含你的个人资料。尽管我们可能取得你的电脑或其他电子设备的资料（如IP地址、浏览器设定、浏览纪录及／或其他互联网纪录资料），但未必可以识别你的身分。由于非个人资料与个人资料溷杂，就私隐政策而言，我们视有关资料为个人资料。在若干情况下，我们可以收集你的个人资料，但必须经你填妥网上表格自愿提供，或于你在我们的网页及移动应用程式购买货品或使用服务时收集。
      </p>
      <p className={styles.msg}>
        假如你不允许「曲奇」档桉的使用，可在互联网浏览器及电子装置上作出调整。如你停用「曲奇」档桉，即表明你知道可能无法使用我们网页及移动应用程式的某些功能。
      </p>
      <p className={styles.msg} style={{ height: 21 }}></p>
      <p className={styles.keynote}>连线网页</p>

      <p className={styles.msg}>
        本私隐政策声明只适用于本公司网页及移动应用程式。我们网页及移动应用程式可能载有通往其他网址及网页的连线点。
        每当你启动任何此等连线网址，例如点选任何广告客户的连线栏目，你即已离开了我们的网址及移动应用程式；而你在离开我们网址及移动应用程式后向任何其他团体提供的任何个人资料或任何其他资料，一概不在本公司的管控范围内。
        你须承担一切浏览或使用其他网址的风险。
      </p>
      <p className={styles.msg} style={{ height: 21 }}></p>
      <p className={styles.keynote}>个人资料之查阅及更正</p>
      <p className={styles.msg}>
        如你对正念之私隐政策有任何疑问，或有意查阅或更正个人资料，你可以书面方式通知我们
        。
      </p>

      <p className={styles.msg}>
        按照条例，本公司保留权利就有关的查阅资料要求向你收取合理的费用。
      </p>
      <p className={styles.msg}>本私隐政策会定期审阅及于网站上更新。</p>
      <p className={styles.msg} style={{ height: 21 }}></p>
      <p className={styles.msg}>最近更新日期：2020年</p>
      <p className={styles.msg} style={{ height: 21 }}></p>
    </div>
  );
}
